export const AUTH_BASEURL = "https://givbko3t7h.execute-api.ap-northeast-1.amazonaws.com";
export const USER_PRODUCT_BASEURL = "https://xatvyyfpu8.execute-api.ap-northeast-1.amazonaws.com";
export const USER_ADMIN_BASEURL = "https://mnx56yp992.execute-api.ap-northeast-1.amazonaws.com";
export const USER_USER_BASEURL = "https://e4r32kr1p0.execute-api.ap-northeast-1.amazonaws.com";
export const TENANT_API_BASEURL = "https://m13to93uk8.execute-api.ap-northeast-1.amazonaws.com";

export const USERPOOL_ID = "ap-northeast-1_4AgoxwZTv";
export const APPCLIENT_ID = "43ptgvdcbn7rc0ob5cd5iunt2j";

